import LarsseitRegularHintWoff from './font-faces/LarsseitRegular-hint-all.woff';
import LarsseitRegularHintWoff2 from './font-faces/LarsseitRegular-hint-all.woff2';
import LarsseitMediumHintWoff from './font-faces/LarsseitMedium-hint-all.woff';
import LarsseitMediumHintWoff2 from './font-faces/LarsseitMedium-hint-all.woff2';
import LarsseitBoldHintWoff from './font-faces/LarsseitBold-hint-all.woff';
import LarsseitBoldHintWoff2 from './font-faces/LarsseitBold-hint-all.woff2';

const createUrl = (fontWoff2, fontWoff) =>
  `url(${fontWoff2}) format('woff2'), url(${fontWoff}) format('woff')`;
const loadHintFonts = () => {
  const regularUrl = createUrl(
    LarsseitRegularHintWoff2,
    LarsseitRegularHintWoff
  );
  const mediumUrl = createUrl(LarsseitMediumHintWoff2, LarsseitMediumHintWoff);
  const boldUrl = createUrl(LarsseitBoldHintWoff2, LarsseitBoldHintWoff);

  if ('fonts' in document && typeof FontFace !== 'undefined') {
    const regular = new FontFace('Larsseit', regularUrl, { weight: 400 });
    const medium = new FontFace('Larsseit', mediumUrl, { weight: 700 });
    const bold = new FontFace('Larsseit', boldUrl, { weight: 900 });

    return Promise.all([regular.load(), medium.load(), bold.load()]).then(
      (fonts) => {
        fonts.forEach((font) => document.fonts.add(font));
      }
    );
  }

  return Promise.resolve().then(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @font-face {
        font-style: normal;
        font-weight: 400;
        font-family: 'Larsseit';
        src: ${regularUrl};
        font-display: swap;
      }

      @font-face {
        font-style: normal;
        font-weight: 700;
        font-family: 'Larsseit';
        src: ${mediumUrl};
        font-display: swap;
      }

      @font-face {
        font-style: normal;
        font-weight: 900;
        font-family: 'Larsseit';
        src: ${boldUrl};
        font-display: swap;
      }
    `;

    document.querySelector('head').appendChild(style);
  });
};

export default loadHintFonts;
